import * as SocialChannelsEffects from './social-channels.effect';

export const effects = { ...SocialChannelsEffects };
